
// 利用es6 import 机制获取vue
import _this from '../main.js'
import {onlyView} from './onlyView'

// 全局使用 一个onstorage 监听
// 为每一个 onlyView.js 的 属性储存随机数 
// 例 'billsCP' 储存的随机数为 'billsCPRandom'
window.onstorage = e => {
    let atr = null;
    for (const key in onlyView) {
        if (Object.hasOwnProperty.call(onlyView, key)) {
            if (e.key == onlyView[key]) {
                atr = e.key + 'Random'
                break;
            }
        }
    }
    // console.log('atr',atr);
    // console.log('e',e);
    if (atr) {
        // 设置vuex 使得页面监听变化
        _this.$store.commit('randomLocalstorage/setRandomLocalstorage', {
            [atr]: e.newValue,
        });
    }
    // console.log('onstorage',e);
};



// WEBPACK FOOTER //
// ./src/utils/onStorage.js